import React, { forwardRef, useImperativeHandle } from 'react';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import { ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import AutoCompleteMenu from '@wix/da-ds/pkg/formControls/layouts/AutoCompleteLayout/AutoCompleteMenu';
import { useAutoCompleteKeyboardSupport } from '@wix/da-ds/pkg/formControls/layouts/AutoCompleteLayout/hooks';
import s from './MentionList.scss';
export default /*#__PURE__*/ forwardRef((props, ref)=>{
    const menuId = useUniqueId();
    const selectItem = (item)=>{
        if (item.username) {
            props.command({
                user: item
            });
        } else {
            props.command({
                user: props.items[item.value]
            });
        }
    };
    const [selectedIndex, onKeyDown] = useAutoCompleteKeyboardSupport(props.items, selectItem);
    useImperativeHandle(ref, ()=>({
            onKeyDown: ({ event })=>onKeyDown(event)
        }));
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return(// TODO: AutoCompleteMenu is not meant to be used on its own, so a11y doesn't quite work here.
    // We need to figure out if we can alter the relevant editor node whilst the autocomplete menu is open.
    // Will have to apply the appropriate aria to said node attributes (see AutoCompleteLayout for an example of those).
    /*#__PURE__*/ React.createElement(ThemeOverride, {
        themeSurface: ThemeSurface.TERTIARY
    }, /*#__PURE__*/ React.createElement(AutoCompleteMenu, {
        menuId: menuId,
        items: props.items ? props.items.map((item, index)=>{
            var _item_icon;
            return {
                label: /*#__PURE__*/ React.createElement("div", {
                    className: s['user']
                }, /*#__PURE__*/ React.createElement("img", {
                    src: (_item_icon = item.icon) !== null && _item_icon !== void 0 ? _item_icon : 'https://a.deviantart.net/avatars/default.gif',
                    height: "25",
                    alt: item.username
                }), ' ', item.username),
                value: index
            };
        }) : [],
        onSelectItem: selectItem,
        selectedIndex: selectedIndex,
        className: s['root']
    })));
});

//# sourceMappingURL=MentionList.js.map